import advancedFieldsToCompanyService from 'resources/advanced-fields-to-company/advanced-fields-to-company.service';
import advancedFieldsService from 'resources/advanced-fields/advanced-fields.service';

const createAdvancedFields = async ({ companyId }) => {
  const generalAdvancedFields = await advancedFieldsService.find({ is_general: true });

  const relations = generalAdvancedFields.map((field) => ({
    field_id: field.id,
    company_id: companyId,
    is_active: true,
  })).filter((relation) => !!relation);

  await advancedFieldsToCompanyService.createMany(relations);
};

export { createAdvancedFields };
